var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14014 8.93481H3.54443L2.86084 10.9856H0.680176L4.38525 1.03247H6.28564L10.0112 10.9856H7.83057L7.14014 8.93481ZM4.09814 7.27368H6.58643L5.33545 3.5481L4.09814 7.27368ZM10.5034 7.23267C10.5034 6.07967 10.7609 5.16138 11.2759 4.47778C11.7954 3.79419 12.5041 3.45239 13.4019 3.45239C14.1219 3.45239 14.7166 3.72127 15.186 4.25903V0.485596H17.1685V10.9856H15.3843L15.2886 10.1995C14.7964 10.8147 14.1629 11.1223 13.3882 11.1223C12.5177 11.1223 11.8182 10.7805 11.2896 10.0969C10.7655 9.40877 10.5034 8.45402 10.5034 7.23267ZM12.479 7.37622C12.479 8.06893 12.5998 8.59985 12.8413 8.96899C13.0828 9.33813 13.4338 9.52271 13.894 9.52271C14.5047 9.52271 14.9354 9.26522 15.186 8.75024V5.8313C14.9399 5.31632 14.5138 5.05884 13.9077 5.05884C12.9552 5.05884 12.479 5.8313 12.479 7.37622Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/Ad.b463761b4c73ebb69d44861d7fe4da01.svg";
export { ForwardRef as ReactComponent };